module.exports = __webpack_public_path__ + "media/03-02-video.98953c4c.mp4";